import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  FormGroup,
  Form,
  Label,
  Row,
  Col,
} from 'reactstrap'
import styled from 'styled-components'
import { generateButton } from '../helpers/button'

export const SubmitTimesheetForm = (props) => {
  const { submitMyTimesheet, handleSubmitRemark } = props
  const { open } = props
  return (
  /* eslint no-underscore-dangle: 0 */
    <div>
      <Modal
        isOpen={ open }
        toggle={ () => submitMyTimesheet('cancel') }
      >
        <HeaderForm toggle={ () => submitMyTimesheet('cancel') }>
          <HeadLabel>Submit Timesheet</HeadLabel>
        </HeaderForm>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Form onSubmit={ (e) => e.preventDefault() }>
                <FormGroup>
                  <Container >
                    <Row style={ { marginTop: 10 } }>
                      <Col sm={ 4 }>
                        <TextLabel >Remarks (Optional)</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <TextArea
                          name="submit_remark"
                          onBlur={ (e) => handleSubmitRemark(e) }
                        />
                      </Col>
                    </Row>
                  </Container>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          { generateButton('submit', (type) => props.submitMyTimesheet(type)) }
        </ModalFooter>
      </Modal>
    </div>
  )
}

SubmitTimesheetForm.propTypes = {
  submitMyTimesheet: PropTypes.func,
  open: PropTypes.bool,
  handleSubmitRemark: PropTypes.func,
}
SubmitTimesheetForm.defaultProps = {
  submitMyTimesheet: () => {},
  open: false,
  handleSubmitRemark: () => {},
}

const TextArea = styled.textarea`
  width: 100%;
  border: 1px solid #cccccc;
  font-family: 'Gotham' !important;
`
const HeaderForm = styled(ModalHeader)`
  font-family: 'Gotham-Bold' !important;
  font-size: 12px ;
`
const HeadLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  color: #AD2624;
  margin-left: 5px;
`
const TextLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
  margin-left: 5px;
`




// WEBPACK FOOTER //
// ./src/components/timesheet/form/submit-timesheet.js